import { useRecoilValue } from 'recoil'
import { authenticatedUserAtom } from 'state'
import AuthenticatedUnsubscribe from './AuthenticatedUnsubscribe'
import AnonymousUnsubscribe from './AnonymousUnsubscribe'
import { Stack } from '@mui/material'
import Toast from 'components/AuthenticatedContainer/Toast'

const Unsubscribe = () => {
  const user = useRecoilValue(authenticatedUserAtom)

  return (
    <Stack>
      {user ? <AuthenticatedUnsubscribe /> : <AnonymousUnsubscribe />}
      <Toast />
    </Stack>
  )
}

export default Unsubscribe
